export const getCustomerState = state => state.getcustomerState;
